import {
  Dimension,
  DimensionId,
  DimensionsSummary,
  DimensionWithConfig,
} from "@/types/questionnaries";
import { Driver, People, Tree } from "iconsax-react";
import { Lightbulb, Scale } from "lucide-react";

export const dimensions: Dimension[] = [
  {
    id: "COMPANY_INFORMATION",
    label: "Información de la empresa",
    color: "#FE7D39",
    icon: Driver,
  },
  {
    id: "GOVERNANCE",
    label: "Gobernanza",
    icon: Scale,
    color: "#9491CF",
  },
  {
    id: "BUSINESS_MODEL_AND_INNOVATION",
    label: "Modelo de negocio e innovación",
    icon: Lightbulb,
    color: "#F0A000",
  },
  {
    id: "ENVIRONMENTAL",
    label: "Ambiental",
    icon: Tree,
    color: "#6CDA96",
  },
  {
    id: "SOCIAL",
    label: "Social",
    icon: People,
    color: "#EF3340",
  },
];

export const getDimensionById = (id: DimensionId) =>
  dimensions.find((d) => d.id === id);

export const mergeWithConfig = (dimension: DimensionsSummary) => {
  const config = getDimensionById(dimension.dimension);

  const dimensionWithConfig: DimensionWithConfig = {
    ...dimension,
    icon: config?.icon,
    color: config?.color,
    label: config?.label || "",
  };

  return dimensionWithConfig;
};
